The geographic coordinates of the position location.
